import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadSharedTenderSubfolders } from '~src/services/api/shares';
import { DbTenderFolder } from '~src/types/db';

interface UseSharedTenderFoldersParams {
  share_id?: string;
  share_key?: string;
  root_folder_id?: string;
}

export const useSharedTenderSubfolders = (
  { share_id, share_key, root_folder_id }: UseSharedTenderFoldersParams = {},
  queryConfig: QueryConfig<DbTenderFolder[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const { enabled, ...options } = queryConfig;
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderFoldersQuery = useQuery<DbTenderFolder[], AxiosError>(
    [
      'sharedTenderSubFolders',
      {
        share_id,
        share_key,
        root_folder_id,
      },
    ],
    loadSharedTenderSubfolders,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return tenderFoldersQuery;
};
